export default __webpack_public_path__ + "static/media/pic8.a34c7d5b.jpg";